import React, { useEffect, useState, useContext } from "react"
import { SettingsContext } from "../../providers/settings";
import { SearchContext } from "../../providers/search";
import HomePageLayout from "../../layouts/HomePage/HomePageLayout";
import { Stack, Box, ArrowBack, Typography, GTIWebButton, GTIWebSelect, GTIWebTextField } from "@gti-controls-v2/web-core";
import Title from "../../components/title";
import ModalTicket from "../../components/modal-ticket";
import ListCardResult from "../../components/card-list";
import useSearch from "../../hooks/useSearch";
import useModal from "../../hooks/useModal";
import useLookup from "../../hooks/useLookups";
import useTicket from "../../hooks/useTicket";
import { useNavigate } from "react-router-dom";
import { paths } from "../../common/constants/Rutas";
import { statesCodesById } from "../../common/utilities/index";

export const ResultSearchPage = () => {
    const initReasonState = {
        ticketReason: {
            motivoTicket: 0,
            medioTicket: 0,
            referencia: ""
        },
    };
    const { isLoading, handleLoading } = useContext(SettingsContext);
    const { state: search } = useContext(SearchContext);
    const { isShowing, modalData, open, close } = useModal();
    const navigate = useNavigate();
    const { getEmployeeByCURP, getEmployeeByForm } = useSearch();
    const { getTicketReason, getTicketMedium } = useLookup();
    const { postCreateTicket } = useTicket();
    const [usuarioResult, setUsuarioResult] = useState([]);
    const [motivoTicket, setMotivoTicket] = useState(null);
    const [medtioTicket, setMedioTicket] = useState(null);
    const [reasonTicket, setReasonTicket] = useState(initReasonState);
    const [errors, setErrors] = useState({});
    const [errorTicket, setErrorTicket] = useState(null);
    const [sizeOfResult, setSizeOfResult] = useState(0);

    useEffect(() => {
        if (search.typeSearch === 'CURP' && search.byCURP.curp) {
            getEmployeeByCURPHandler(search.byCURP.curp);
        } else if (search.typeSearch === 'FORM' && (search.byForm.nombre || search.byForm.apellido)) {
            getEmployeeByFormHandler(search.byForm);
        }
        // eslint-disable-next-line
    }, [search])

    const getEmployeeByCURPHandler = async (curp) => {
        handleLoading(true);
        const result = await getEmployeeByCURP(curp);
        setUsuarioResult(result.data);
        setSizeOfResult(result.data.length);
        handleLoading(false);
    };

    const getEmployeeByFormHandler = async (input) => {
        handleLoading(true);
        const formatInput = {
            nombre: input.nombre ? input.nombre.trimEnd() : input.nombre,
            apellido: input.apellido ? input.apellido.trimEnd() : input.apellido
        }
        const result = await getEmployeeByForm(formatInput.nombre, formatInput.apellido, input.fechaNacimiento, statesCodesById(input.estadoNacimiento));
        setUsuarioResult(result.data);
        setSizeOfResult(result.data.length);
        handleLoading(false);
    };


    const handleOpenTicket = async (e, record) => {
        try {
            handleLoading(true);
            const [resultMotivos, resultMedios] = await Promise.all([
                getTicketReason(),
                getTicketMedium()
            ]);
            handleLoading(false);

            if (resultMotivos.exitoso && resultMedios.exitoso) {
                setMotivoTicket(resultMotivos.data);
                setMedioTicket(resultMedios.data);
                open(record);
            }
        } catch (error) {
            handleLoading(false);
        }
    };

    const handleBack = () => {
        navigate(paths.HomePage);
    };

    const onModalClosed = async (confirm) => {
        handleLoading(true);
        if (confirm) {
            if (validateReason()) {
                let resultPostTicket;
                try {
                    const bodyTicket = {
                        MotTikID: reasonTicket.ticketReason.motivoTicket,
                        MedTikID: reasonTicket.ticketReason.medioTicket,
                        Referencia: reasonTicket.ticketReason.referencia,
                        CURP: modalData.curp,
                        Nombre: modalData.nombre
                    };

                    resultPostTicket = await postCreateTicket(bodyTicket);

                    if (resultPostTicket?.exitoso) {
                        close();
                        navigate(paths.TicketPage, { state: { ...modalData, TicketID: resultPostTicket.data.TicketID }})
                    } else{
                        setErrorTicket({
                            message: resultPostTicket.data
                        });
                    }
                } catch (error) {
                    console.log("[Error on postCreateTicket]:", error);
                    
                    setErrorTicket({
                        message: "Ocurrió un error."
                    });
                }
            }
        } else {
            close();
        }
        handleLoading(false);
    };

    const handlerOnChange = (e) => {
        setErrors({});
        const { name, value } = e.target;
        setReasonTicket((prev) => ({
            ...prev,
            ticketReason: {
                ...prev.ticketReason,
                [name]: value,
            },
        }));
    };

    const validateReason= () => {
        const newErrors = {};
        if (reasonTicket.ticketReason.motivoTicket === 0) {
            newErrors.motivoTicket = "Seleccione un motivo";
        }
        if (reasonTicket.ticketReason.medioTicket === 0) {
            newErrors.medioTicket = "Seleccione un medio de contacto";
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    return (
        <HomePageLayout>

            <ModalTicket 
                open={isShowing} 
                title="Nuevo Ticket"
                onClose={onModalClosed} 
                error={errorTicket}
                isLoading={isLoading}
            >
                <Stack spacing={2}>
                    <GTIWebSelect
                        name="motivoTicket"
                        dataSource={motivoTicket}
                        displayedValue="MotTikNombre"
                        selectedValue="MotTikID"
                        labelText="Seleccionar motivo de ticket"
                        color={"secondary"}
                        onChange={handlerOnChange}
                        disableDefaultReadOnly
                        required
                        error={errors.motivoTicket}
                        disabled={isLoading}
                    />

                    <GTIWebSelect
                        name="medioTicket"
                        dataSource={medtioTicket}
                        displayedValue="MedTikNombre"
                        selectedValue="MedTikID"
                        labelText="Seleccionar medio de contacto"
                        color={"secondary"}
                        onChange={handlerOnChange}
                        disableDefaultReadOnly
                        required
                        error={errors.medioTicket}
                        disabled={isLoading}
                    />

                    <GTIWebTextField
                        name="referencia"
                        labelText="Referencia (Opcional)"
                        width="100%"
                        autoFocus={true}
                        autoComplete={"off"}
                        onBlur={handlerOnChange}
                        onChange={handlerOnChange}
                        textArea={5}
                        disabled={isLoading}
                    />
                </Stack>
            </ModalTicket>

            <Stack direction="column" spacing={2} align="left" paddingBottom={4}>
                <Stack direction="row" spacing={2} alignItems="center">
                    <GTIWebButton 
                        icon={<ArrowBack/>}
                        iconPosition="start"
                        onlyIcon={true}
                        onClick={handleBack}
                        loading={isLoading}
                    />
                    <Title>Resultados</Title>
                </Stack>
                <Box paddingLeft={6}>
                    <Typography variant="body2" sx={{ color: "text.secondary" }}>
                        {sizeOfResult + " resultado(s)"} 
                    </Typography>
                </Box>
            </Stack>

            <ListCardResult 
                dataSet={usuarioResult} 
                handleOpenTicket={handleOpenTicket}
            />
        </HomePageLayout>
    );
};

export default ResultSearchPage;